var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"success-svg"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"-263.5 236.5 26 26"}},[_c('g',{staticClass:"svg-success"},[_c('circle',{attrs:{"cx":"-250.5","cy":"249.5","r":"12"}}),_c('path',{attrs:{"d":"M-256.46 249.65l3.9 3.74 8.02-7.8"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }